<div
  (click)="toggleSidebar()"
  class="c-subnav__title--expander"
  [class.is-fixed]="fixed"
>
  <i class="fa fa-bars" aria-hidden="true"></i>
</div>
